// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.

// Shortcuts for editor2
export const EDITOR2_SHORTCUTS = {
	PUBLISH: 'mod+enter',
	PUBLISH_WITH_COMMENT: 'mod+shift+enter',
	EDIT: 'e',
	PREVIEW: 'mod+shift+e',
	UNDO: 'mod+z',
	REDO: 'mod+shift+z',
	FIND_REPLACE: 'mod+f',
};
export const BROWSER_SAVE_SHORTCUT = 'mod+s';
export const COMMENT_EDITOR_SHORTCUT = 'command+enter';
export const INLINE_COMMENTS_SHORTCUT = 'mod+enter';
export const BLOG_SHORTCUT = 'b';
export const GLOBAL_CREATE_SHORTCUT = 'c';
export const STAR_BUTTON_SHORTCUT = 'f';
export const CREATE_COMMENT_SHORTCUT = 'm';
export const LINK_TO_THIS_PAGE_SHORTCUT = 'k';
export const EDIT_SHORTCUT = 'e';
export const PRESENTATION_MODE_SHORTCUT = 'r';
export const WATCH_CONTENT_SHORTCUT = 'w';
export const SHARE_PAGE_SHORTCUT = 's';
export const LABELS_SHORTCUT = 'l';
export const VIEW_ATTACHMENTS_SHORTCUT = 't';
export const NEXT_COMMENT_SHORTCUT = 'n';
export const PREV_COMMENT_SHORTCUT = 'p';
export const SUBMIT_FEEDBACK_SHORTCUT = 'g f';
export const NAVIGATION_SHORTCUT = 'g g';
export const GO_HOME_SHORTCUT = 'g d';
export const NOTIFICATIONS_SHORTCUT = 'g n';
export const GO_TO_RECENT_SHORTCUT = 'g r';
export const GO_TO_STARRED_SHORTCUT = 'g s';
export const SPACE_OVERVIEW_SHORTCUT_NAV_3 = 'g s';
export const SPACE_OVERVIEW_SHORTCUT = 'g o';
export const AI_MATE_SHORTCUT = 'g c';
export const NAVIGATION_SLASH_SHORTCUT = '/';
export const SIDE_NAVIGATION_SHORTCUT = '[';
export const UNDO_SHORTCUT = 'mod+z';
export const PREV_TEMPLATE_SHORTCUT = 'left';
export const NEXT_TEMPLATE_SHORTCUT = 'right';
export const HELP_SHORTCUT = '?';
export const AUTOMATION_SHORTCUT = 'a';
export const TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER = ']';
// All the shortcuts below are editing specific
export const TOGGLE_INLINE_COMMENTS_SHORTCUT_EDITOR = 'ctrl+]';
export const GLOBAL_CREATE_SHORTCUT_IN_EDIT_MAC = 'ctrl+option+c';
export const GLOBAL_CREATE_SHORTCUT_IN_EDIT_WIN = 'ctrl+alt+p';
export const HELP_SHORTCUT_IN_EDIT = 'ctrl+shift+/';
export const SIDE_NAVIGATION_SHORTCUT_IN_EDIT = 'ctrl+[';
export const STAR_BUTTON_SHORTCUT_IN_EDIT = 'ctrl+option+f';
export const LIVE_PAGE_MODE_SWITCH_TO_EDIT = 'e';
export const LIVE_PAGE_MODE_SWITCH_TO_VIEW = 'mod+shift+e';
//Universal shortcuts used across all page modes
export const UNIVERSAL_NEXT_COMMENT_SHORTCUT = 'ctrl+.';
export const UNIVERSAL_PREV_COMMENT_SHORTCUT = 'ctrl+,';
export const UNIVERSAL_OPEN_COMMENT_EDITOR = 'mod+option+c';
export const UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT = 'mod+shift+l';
export const UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT = 'mod+shift+u';
export const UNIVERSAL_PRESENTATION_MODE_SHORTCUT = 'mod+option+r';
export const UNIVERSAL_WATCH_CONTENT_SHORTCUT = 'mod+option+w';
export const UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT = 'ctrl+shift+i';
export const UNIVERSAL_LABELS_SHORTCUT = 'ctrl+option+a';
